module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-13-7ca97d85f7059a5df7aeaaf6102cc697.jpg";